const ARTICLE_REACTION_ONBOARDING_COOKIES = {
  www: 'articleReactionsOnboardingRuCookie',
  kaz: 'articleReactionsOnboardingKazCookie'
};

const MAXIMUM_DAYS_FOR_DELAY = 45;
const HOURS_PER_DAY = 24;

// 45 days * 24 hours for cookie
const ARTICLE_REACTION_ONBOARDING_LONG_TTL_HOURS = MAXIMUM_DAYS_FOR_DELAY * HOURS_PER_DAY;

const GROWTHBOOK_ACTIVE_VALUES = ['group_b', 'group_c', 'group_d'];

const ONBOARDING_CLOSE_TIMEOUT = 10000;

const CLOSE_ONBOARDING_SOURCES = {
  CLICK: 'click',
  TIMEOUT: 'timeout'
};

export {
  ARTICLE_REACTION_ONBOARDING_LONG_TTL_HOURS,
  GROWTHBOOK_ACTIVE_VALUES,
  ARTICLE_REACTION_ONBOARDING_COOKIES,
  ONBOARDING_CLOSE_TIMEOUT,
  CLOSE_ONBOARDING_SOURCES
};
